export const DialogFooter: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <div
      data-dialog-footer
      className="flex justify-end gap-3 border-t p-4 sm:px-6"
    >
      {children}
    </div>
  );
};
